import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-11 w-full rounded-lg border border-neutral-300 bg-white px-3 text-base text-yhelp-black',
        'placeholder:text-neutral-400 focus-visible:border-yhelp-yellow focus-visible:outline-none',
        'dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-100 dark:placeholder:text-neutral-500',
        invalid && 'border-priority-critico',
        className,
      )}
      {...rest}
    />
  );
});
